import { indexItems } from '@/mocks/homeData';

const iconColors = [
  'text-primary-500 bg-primary-50',
  'text-accent-500 bg-accent-50',
  'text-secondary-600 bg-secondary-100',
  'text-primary-600 bg-primary-50',
  'text-accent-600 bg-accent-50',
  'text-secondary-700 bg-secondary-100',
  'text-primary-500 bg-primary-50',
  'text-accent-500 bg-accent-50',
  'text-secondary-600 bg-secondary-100',
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">
          专题合集索引
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-12 max-w-xl mx-auto">
          精心策划的观影专题，总有你感兴趣的主题
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item, i) => (
            <div
              key={item.title}
              className="flex items-start gap-4 bg-background-100 rounded-lg p-5 cursor-pointer hover:bg-secondary-50 transition-colors group"
            >
              <div className={`w-12 h-12 rounded-lg flex items-center justify-center text-xl shrink-0 ${iconColors[i % iconColors.length]}`}>
                <i className={item.icon}></i>
              </div>
              <div className="min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <span className="text-xs text-primary-500 bg-primary-50 px-1.5 py-0.5 rounded shrink-0">
                    {item.count}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}